<template>
  <div class="detail-info-content">
    <div v-if="showHeadBtn" class="head-btn-group">
      <div class="left-btn-group">
        <div
          v-for="(btn, index) in btnList"
          v-show="!btn.hidden"
          v-rect-loading="btn.loading"
          class="head-btn-wrapper"
          :key="index"
        >
          <slot :name="btn.slotName" :label="btn.label" :btn="btn">
            <el-popconfirm
              v-if="btn.confirm"
              :title="btn.confirmTitle"
              :confirm-button-text="btn.confirmBtnLabel"
              :cancel-button-text="btn.cancelBtnLabel"
              @confirm="onconfirm(btn)"
              @cancel="oncancel(btn)">
              <template #reference>
                <slot :name="btn.confirmSlotName" :btn="btn">
                  <el-button v-if="btn.tooltip" v-auto-tooltip.always="btn.tooltip" class="head-btn" :disabled="btn.disabled">{{ btn.label }}</el-button>
                  <el-button v-else class="head-btn" :disabled="btn.disabled">{{ btn.label }}</el-button>
                </slot>
              </template>
            </el-popconfirm>
            <template v-else>
              <el-button v-if="btn.tooltip" v-auto-tooltip.always="btn.tooltip" class="head-btn" :disabled="btn.disabled" @click="btn.onclick($event, btn)">
                <slot :name="btn.labelSlotName" :btn="btn" :label="btn.label">{{ btn.label }}</slot>
              </el-button>
              <el-button v-else class="head-btn" :disabled="btn.disabled" @click="btn.onclick($event, btn)">
                <slot :name="btn.labelSlotName" :btn="btn" :label="btn.label">{{ btn.label }}</slot>
              </el-button>
            </template>
          </slot>
        </div>
      </div>
      <div class="right-btn-group">
        <el-dropdown v-if="filteredActionBtnList?.length" class="action-btn-wrapper" ref="actionBtnDropdown" trigger="click" :hide-on-click="false" @command="handleAction">
          <el-button class="action-btn">
            <span class="label">{{ $t('common.label.operate') }}</span>
            <span class="more iconfont icona-xingzhuangbeifen8"></span>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <template v-for="(btn, index) in filteredActionBtnList">
                <el-dropdown-item
                  v-if="btn.tooltip"
                  v-auto-tooltip.always="getBtnTooltip(btn, 'left')"
                  v-rect-loading="btn.loading"
                  class="head-btn-wrapper"
                  :key="`tooltip_${index}`"
                  :class="btn.loading && 'is-loading'"
                  :command="btn"
                  :disabled="btn.disabled"
                >
                  <slot :name="btn.slotName" :btn="btn" :label="btn.label">
                    <el-popconfirm
                      v-if="btn.confirm"
                      :title="btn.confirmTitle"
                      :confirm-button-text="btn.confirmBtnLabel"
                      :cancel-button-text="btn.cancelBtnLabel"
                      @confirm="groupBtnOnConfirm(btn)"
                      @cancel="groupBtnOnCancel(btn)"
                    >
                      <template #reference>
                        <slot :name="btn.confirmSlotName" :btn="btn">
                          <div class="confirm-btn-trigger">
                            {{ btn.label }}
                          </div>
                        </slot>
                      </template>
                    </el-popconfirm>
                    <el-dropdown
                      v-else-if="btn.subBtnList || btn.subBtnListLoader"
                      class="sub-menu-trigger-dropdown"
                      placement="left"
                      trigger="click"
                      :ref="`subMenuDropdown_${index}`"
                      :hide-on-click="false"
                      @command="handleSubMenuAction(btn, index, $event)"
                    >
                      <div class="sub-menu-trigger">
                        <slot :name="btn.labelSlotName" :btn="btn" :label="btn.label">{{ btn.label }}</slot>
                      </div>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <template v-for="(subBtn, index) in filterShowBtnList(btn.subBtnList)">
                            <el-dropdown-item
                              v-if="subBtn.tooltip"
                              v-auto-tooltip.always="getBtnTooltip(subBtn, 'left')"
                              v-rect-loading="btn.loading || subBtn.loading"
                              class="head-btn-wrapper"
                              :key="`tooltip_${index}`"
                              :class="(btn.loading || subBtn.loading) && 'is-loading'"
                              :command="subBtn"
                              :disabled="subBtn.disabled"
                            >
                              <slot :name="btn.subBtnSlotName || subBtn.slotName" :btn="subBtn" :label="subBtn.label">
                                <el-popconfirm
                                  v-if="subBtn.confirm"
                                  :title="subBtn.confirmTitle"
                                  :confirm-button-text="subBtn.confirmBtnLabel"
                                  :cancel-button-text="subBtn.cancelBtnLabel"
                                  @confirm="groupBtnOnConfirm(subBtn)"
                                  @cancel="groupBtnOnCancel(subBtn)"
                                >
                                  <template #reference>
                                    <slot :name="subBtn.confirmSlotName" :btn="subBtn">{{ subBtn.label }}</slot>
                                  </template>
                                </el-popconfirm>
                                <template v-else>
                                  {{ subBtn.label }}
                                </template>
                              </slot>
                            </el-dropdown-item>
                            <el-dropdown-item
                              v-else
                              v-rect-loading="btn.loading || subBtn.loading"
                              class="head-btn-wrapper"
                              :key="index"
                              :class="(btn.loading || subBtn.loading) && 'is-loading'"
                              :command="subBtn"
                              :disabled="subBtn.disabled"
                            >
                              <slot :name="btn.subBtnSlotName || subBtn.slotName" :btn="subBtn" :label="subBtn.label">
                                <el-popconfirm
                                  v-if="subBtn.confirm"
                                  :title="subBtn.confirmTitle"
                                  :confirm-button-text="subBtn.confirmBtnLabel"
                                  :cancel-button-text="subBtn.cancelBtnLabel"
                                  @confirm="groupBtnOnConfirm(subBtn)"
                                  @cancel="groupBtnOnCancel(subBtn)"
                                >
                                  <template #reference>
                                    <slot :name="subBtn.confirmSlotName" :btn="subBtn">{{ subBtn.label }}</slot>
                                  </template>
                                </el-popconfirm>
                                <template v-else>
                                  {{ subBtn.label }}
                                </template>
                              </slot>
                            </el-dropdown-item>
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <template v-else>
                      {{ btn.label }}
                    </template>
                  </slot>
                </el-dropdown-item>
                <el-dropdown-item
                  v-else
                  v-rect-loading="btn.loading || btn.subBtnListLoading"
                  class="head-btn-wrapper"
                  :key="index"
                  :class="btn.loading && 'is-loading'"
                  :command="btn"
                  :disabled="btn.disabled"
                >
                  <slot :name="btn.slotName" :btn="btn" :label="btn.label">
                    <el-popconfirm
                      v-if="btn.confirm"
                      :title="btn.confirmTitle"
                      :confirm-button-text="btn.confirmBtnLabel"
                      :cancel-button-text="btn.cancelBtnLabel"
                      @confirm="groupBtnOnConfirm(btn)"
                      @cancel="groupBtnOnCancel(btn)"
                    >
                      <template #reference>
                        <slot :name="btn.confirmSlotName" :btn="btn">
                          <div class="confirm-btn-trigger">
                            {{ btn.label }}
                          </div>
                        </slot>
                      </template>
                    </el-popconfirm>
                    <el-dropdown
                      v-else-if="btn.subBtnList || btn.subBtnListLoader"
                      class="sub-menu-trigger-dropdown"
                      placement="left"
                      trigger="click"
                      :ref="`subMenuDropdown_${index}`"
                      :hide-on-click="false"
                      @command="handleSubMenuAction(btn, index, $event)"
                    >
                      <div class="sub-menu-trigger">
                        <slot :name="btn.labelSlotName" :btn="btn" :label="btn.label">{{ btn.label }}</slot>
                      </div>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <template v-for="(subBtn, index) in filterShowBtnList(btn.subBtnList)">
                            <el-dropdown-item
                              v-if="subBtn.tooltip"
                              v-auto-tooltip.always="getBtnTooltip(subBtn, 'left')"
                              v-rect-loading="btn.loading || subBtn.loading"
                              class="head-btn-wrapper"
                              :key="`tooltip_${index}`"
                              :class="(btn.loading || subBtn.loading) && 'is-loading'"
                              :command="subBtn"
                              :disabled="subBtn.disabled"
                            >
                              <slot :name="btn.subBtnSlotName || subBtn.slotName" :btn="subBtn" :label="subBtn.label">
                                <el-popconfirm
                                  v-if="subBtn.confirm"
                                  :title="subBtn.confirmTitle"
                                  :confirm-button-text="subBtn.confirmBtnLabel"
                                  :cancel-button-text="subBtn.cancelBtnLabel"
                                  @confirm="groupBtnOnConfirm(subBtn)"
                                  @cancel="groupBtnOnCancel(subBtn)"
                                >
                                  <template #reference>
                                    <slot :name="subBtn.confirmSlotName" :btn="subBtn">{{ subBtn.label }}</slot>
                                  </template>
                                </el-popconfirm>
                                <template v-else>
                                  {{ subBtn.label }}
                                </template>
                              </slot>
                            </el-dropdown-item>
                            <el-dropdown-item
                              v-else
                              v-rect-loading="btn.loading || subBtn.loading"
                              class="head-btn-wrapper"
                              :key="index"
                              :loading="(btn.loading || subBtn.loading) && 'is-loading'"
                              :command="subBtn"
                              :disabled="subBtn.disabled"
                            >
                              <slot :name="btn.subBtnSlotName || subBtn.slotName" :btn="subBtn" :label="subBtn.label">
                                <el-popconfirm
                                  v-if="subBtn.confirm"
                                  :title="subBtn.confirmTitle"
                                  :confirm-button-text="subBtn.confirmBtnLabel"
                                  :cancel-button-text="subBtn.cancelBtnLabel"
                                  @confirm="groupBtnOnConfirm(btn, index, subBtn)"
                                  @cancel="groupBtnOnCancel(btn, index, subBtn)"
                                >
                                  <template #reference>
                                    <slot :name="subBtn.confirmSlotName" :btn="subBtn">{{ subBtn.label }}</slot>
                                  </template>
                                </el-popconfirm>
                                <template v-else>
                                  {{ subBtn.label }}
                                </template>
                              </slot>
                            </el-dropdown-item>
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <template v-else>
                      {{ btn.label }}
                    </template>
                  </slot>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <slot name="afterRightActionBtn"></slot>
      </div>
    </div>
    <div class="content-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    btnList: {
      type: Array,
      default: null
    },
    hideEmptyBtnList: {
      type: Boolean,
      default: false
    },
    actionBtnList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {

    }
  },
  computed: {
    showHeadBtn () {
      if (this.hideEmptyBtnList && (!this.btnList || this.btnList.length < 1) && (!this.actionBtnList || this.actionBtnList.length < 1)) {
        return false
      }
      return true
    },
    filteredActionBtnList () {
      return this.filterShowBtnList(this.actionBtnList)
    }
  },
  created () {

  },
  methods: {
    filterShowBtnList (btnList) {
      return _.reject(btnList, 'hidden')
    },
    getBtnTooltip (btn, placement) {
      if (!btn.tooltip) {
        return
      }
      if (typeof btn.tooltip === 'string') {
        return {
          content: btn.tooltip,
          placement: placement
        }
      } else {
        return {
          placement: placement,
          ...btn.tooltip
        }
      }
    },
    autoCloseDropdown (btn, index, subBtn) {
      const watchBtn = subBtn || btn
      const ref = this.$refs.actionBtnDropdown
      const subRef = subBtn ? this.$refs[`subMenuDropdown_${index}`][0] : null
      if (_.has(watchBtn, 'loading') || _.has(btn, 'loading')) {
        let inLoading = false
        const unwatch = this.$watch(() => watchBtn.loading || btn.loading, (val) => {
          if (val) {
            inLoading = true
          } else if (inLoading) {
            ref.hide()
            subRef?.hide()
            unwatch()
          }
        })
      } else {
        ref.hide()
        subRef?.hide()
      }
    },
    groupBtnOnConfirm (btn, index, subBtn) {
      this.autoCloseDropdown(btn, index, subBtn)
      if (subBtn) {
        if (subBtn.onconfirm) {
          subBtn.onconfirm(subBtn, btn)
        } else {
          subBtn.onclick(subBtn, btn)
        }
      } else {
        if (btn.onconfirm) {
          btn.onconfirm(btn)
        } else {
          btn.onclick(btn)
        }
      }
    },
    groupBtnOnCancel (btn, index, subBtn) {
      this.autoCloseDropdown(btn, index, subBtn)
      if (subBtn) {
        if (subBtn.oncancel) {
          subBtn.oncancel(subBtn, btn)
        }
      } else {
        if (btn.oncancel) {
          btn.oncancel(btn)
        }
      }
    },
    handleAction (btn) {
      if (btn.confirm || btn.disabled || btn.loading) {
        return
      }
      if (btn.subBtnListLoader) {
        if (btn.subBtnListLoading) {

        } else {
          Promise.resolve(btn.subBtnListLoader()).then(() => {
            const index = _.findIndex(this.filterShowBtnList(this.btnList), btn)
            const subRef = this.$refs[`subMenuDropdown_${index}`][0]
            subRef.handleClick()
          })
        }
      } else if (btn.subBtnList) {
        const index = _.findIndex(this.filterShowBtnList(this.btnList), btn)
        const subRef = this.$refs[`subMenuDropdown_${index}`][0]
        subRef.handleClick()
      } else {
        this.autoCloseDropdown(btn)
        btn.onclick(btn)
      }
    },
    handleSubMenuAction (btn, index, subBtn) {
      if (subBtn.confirm || subBtn.disabled || subBtn.loading || subBtn.slotName || btn.disabled || btn.loading || btn.slotName) {
        return
      }
      const ref = this.$refs.actionBtnDropdown
      ref.show() // 防止点击子菜单时，触发clickoutside导致父菜单收起
      this.autoCloseDropdown(btn, index, subBtn)
      subBtn.onclick(subBtn, btn)
    },
    onconfirm (btn) {
      if (btn.onconfirm) {
        btn.onconfirm(btn)
      } else {
        btn.onclick(btn)
      }
    },
    oncancel (btn) {
      if (btn.oncancel) {
        btn.oncancel(btn)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-info-content {
  .head-btn-group {
    display: flex;
    min-height: 30px;
    padding: 18px 40px 20px;

    .left-btn-group {
      flex: 1;

      .head-btn-wrapper {
        display: inline-block;
        margin-top: 10px;
        margin-right: 10px;

        ::v-deep {
          .el-loading-mask {
            .el-loading-spinner {
              margin-top: -14px;
              .spinner {
                height: 26px;
              }

              .el-icon-loading {
                font-size: 18px;
              }
            }
          }
        }
      }
    }

    .right-btn-group {
      margin-left: auto;
      margin-right: 0;
      margin-top: 10px;

      .ai-analysis-action {
        margin-right: 20px;
      }

      .action-btn {
        border-color: #0096cc;
        color: #0096cc;
        font-weight: bold;

        .more {
          font-size: 14px;
        }

        &:hover {
          background-color: #0096cc;
          color: #fff;
        }
      }
    }

    ::v-deep .head-btn {
      padding: 8px 28px;
      border: 1px solid #0096cc;
      color: #0096cc;
      line-height: 22px;
      font-weight: bold;

      &:hover {
        background-color: #0096cc;
        color: #fff;
      }

      &.is-disabled,
      &.is-disabled:focus,
      &.is-disabled:hover {
        color: #c0c4cc;
        border-color: #ebeef5;
        background-color: #ffffff;
      }
    }

    .el-button+.el-button {
      margin-left: 0;
    }
  }

  .content-container {
    padding: 20px 40px;
    border-radius: 0 0 4px 4px;
  }
}

.head-btn-wrapper {
  &.is-disabled {
    cursor: not-allowed;
    pointer-events: unset;
  }
}
</style>
